/* 🤖 this file was generated by svg-to-ts */
export const matIconWbShade: {
  name: 'wb-shade';
  data: string;
} = {
  name: 'wb-shade',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 12v2.5l5.5 5.5H22l-8-8zm0 8h3l-3-3v3zM8 4l-6 6h2v10h8V10h2L8 4zm1 10H7v-4h2v4z"/></svg>`
};
